export const FEED_TYPES = ['regulation', 'event', 'quote'];

export const getLabelFromFeedType = (type) => {
  if (type === 'all') return 'All';
  if (type === 'regulation') return 'Regulations';
  if (type === 'event') return 'Events';
  if (type === 'quote') return 'Quotes';
  return '';
};

export const getTotalsForFeedTypes = (totals) => {
  const totalResults = totals.reduce(
    (acc, total) => ({
      ...acc,
      [total.type]: total.count,
    }),
    {},
  );
  return {
    all: totals.reduce((acc, total) => acc + total.count, 0),
    ...totalResults,
  };
};
